import React from 'react';
import CloudUploadIcon from '../../../../../assets/imgs/icons/cloud_upload.svg';
import CloudErrorIcon from '../../../../../assets/imgs/icons/cloud_error.svg';
import FileSelect from '../../FileSelect';
import FileUploadStatus from '../../FileUploadStatus';
import {
  FileUploadContext,
  MatchedNodeContext
} from '../../../../Utils/Contexts';
import { FileSizeUnitMapping } from '../Constants';
import { FileUploadAPIType } from '../Model';
import { FileDownload } from '../../FileDownload';
import { getFileSize } from '../Utils';

enum Steps {
  Select,
  Upload,
  Download,
  ShowSuccess,
  ShowError
}
interface Props {
  handleSubmit: (msg: string, extraReqObj: any, config?) => void;
  shouldDisableActions: boolean;
  showError: (val: FileUploadAPIType | null) => void;
  displayResponse: string;
}
export function FileUpload(props: Props) {
  const [step, setStep] = React.useState(Steps.Select);
  const [file, setFile] = React.useState<File>(null);

  const fileUploadOnChange = (
    file: File,
    isValidated: boolean,
    val: FileUploadAPIType
  ) => {
    if (isValidated) {
      setStep(Steps.Upload);
      setFile(file);
      props.showError(null);
    } else {
      props.showError(val);
    }
  };

  const fileUploadStatusHandler = (status: boolean) => {
    const fileUpload = {
      uploadedFileDetails: {
        fileName: file.name,
        fileSize: `${getFileSize(file.size)}`
      },
      uploadFileStatus: {
        isValidated: status,
        isFileUpload: true
      }
    };
    const config = { isHidden: true, isFileUpload: true };

    if (status === false) {
      setStep(Steps.ShowError);
      props.handleSubmit('FAILURE', { fileUpload }, config);
    } else {
      props.handleSubmit('SUCCESS', { fileUpload }, config);
      setStep(Steps.Download);
    }
  };

  let disableButton = props.shouldDisableActions && step !== Steps.Download;

  return (
    <div className={`sf-fileupload-w `}>
      <div
        dangerouslySetInnerHTML={{ __html: props.displayResponse }}
        style={{ marginBottom: '12px' }}
      ></div>
      {step === Steps.Select ? (
        <FileUploadContext.Consumer>
          {val => {
            const maxFileSizeInBytes =
              val.fileSizeUnit === FileSizeUnitMapping.KB
                ? val.fileSizeAmount * 1024
                : val.fileSizeUnit === FileSizeUnitMapping.MB
                ? val.fileSizeAmount * 1024 * 1024
                : 0;
            return (
              <MatchedNodeContext.Consumer>
                {context => (
                  <FileSelect
                    icon={CloudUploadIcon}
                    label="UPLOAD"
                    allowedTypes={val.fileSubType}
                    maxFileSizeInBytes={maxFileSizeInBytes}
                    fileSubType={val.fileSubType}
                    disable={disableButton}
                    {...val}
                    {...context}
                    onChange={(file: File, isValidated: boolean) => {
                      fileUploadOnChange(file, isValidated, val);
                    }}
                  />
                )}
              </MatchedNodeContext.Consumer>
            );
          }}
        </FileUploadContext.Consumer>
      ) : step === Steps.Upload ? (
        <FileUploadContext.Consumer>
          {val => (
            <MatchedNodeContext.Consumer>
              {context => (
                <FileUploadStatus
                  file={file}
                  {...val}
                  {...context}
                  then={fileUploadStatusHandler}
                />
              )}
            </MatchedNodeContext.Consumer>
          )}
        </FileUploadContext.Consumer>
      ) : step === Steps.ShowError ? (
        <FileSelect
          icon={CloudErrorIcon}
          label="Upload Failed"
          style={{ color: '#ff4141' }}
          allowedTypes={[]}
          fileSubType={[]}
          fileSizeUnit={0}
          fileUploadAPI=""
          fileSizeAmount={0}
          typeId={0}
          taskId={0}
          workflowId={0}
          botId={0}
          maxFileSizeInBytes={0}
          onChange={() => {}}
          disable={disableButton}
        />
      ) : step === Steps.Download ? (
        <FileDownload file={file} />
      ) : null}
    </div>
  );
}
